<nav-item label="Category"  [hideChevronRight]="true" [ngClass]="{'active': isActive()}">
    <svg-icon key="category" fontSize="1.2rem"></svg-icon>
</nav-item>
